
window.addEventListener('DOMContentLoaded', (event) => {


  // === Product description

  const productDesc = document.querySelector('[data-product-desc]');
  if (productDesc !== null && productDesc !== undefined) {

    const productDescMoreBtn = document.querySelector('[data-product-desc] [data-read-more]');
    if (productDescMoreBtn !== null && productDescMoreBtn !== undefined) {
      productDescMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        productDesc.classList.add('active');
      });
    }
    
    const productDescLessBtn = document.querySelector('[data-product-desc] [data-read-less]');
    if (productDescLessBtn !== null && productDescLessBtn !== undefined) {
      productDescLessBtn.addEventListener('click', (e) => {
        e.preventDefault();
        productDesc.classList.remove('active');
      });
    }
    
  }


  // === Product infos dates

  const productInfosDates = document.querySelector('[data-product-infos-dates]');
  if (productInfosDates !== null && productInfosDates !== undefined) {

    const productDatesMoreBtn = document.querySelector('[data-product-infos-dates-more]');
    if (productDatesMoreBtn !== null && productDatesMoreBtn !== undefined) {
      productDatesMoreBtn.addEventListener('click', (e) => {
        e.preventDefault();
        productInfosDates.classList.add('active');
      });
    }
    
    const productDatesLessBtn = document.querySelector('[data-product-infos-dates-less]');
    if (productDatesLessBtn !== null && productDatesLessBtn !== undefined) {
      productDatesLessBtn.addEventListener('click', (e) => {
        e.preventDefault();
        productInfosDates.classList.remove('active');
      });
    }
    
  }


  // === Product Main

  function productMainPosition(productMain) {

    // Get height of all sections with class 'sejour-section-container'
    let sectionsWithSpecialContainer = document.querySelectorAll('.sejour-section-container');
    let sectionsHeight = 0;
    if (sectionsWithSpecialContainer.length > 0) {
      sectionsWithSpecialContainer.forEach(section => {
        sectionsHeight += section.offsetHeight;
      });
    }

    // Elements height
    const mainRect = productMain.getBoundingClientRect();
    const productBanner = document.querySelector('.product-banner');
    let productBannerHeight = 0;
    if (productBanner !== null && productBanner !== undefined) {
      productBannerHeight = productBanner.offsetHeight;
    }

    // Breakpoint and absolute top position
    let mainProductBreakpoint = ((sectionsHeight + productBannerHeight) - (mainRect.top + productMain.offsetHeight)) - 40;
    let mainAbsoluteTopPosition = mainProductBreakpoint + mainRect.top;

    // On resize: update variables
    window.addEventListener('resize', function(event) {

      // Get height of all sections with class 'sejour-section-container'
      sectionsWithSpecialContainer = document.querySelectorAll('.sejour-section-container');
      sectionsHeight = 0;
      if (sectionsWithSpecialContainer.length > 0) {
        sectionsWithSpecialContainer.forEach(section => {
          sectionsHeight += section.offsetHeight;
        });
      }

      // Elements height
      if (productBanner !== null && productBanner !== undefined) {
        productBannerHeight = productBanner.offsetHeight;
      }

      // Breakpoint and absolute top position
      mainProductBreakpoint = ((sectionsHeight + productBannerHeight) - (mainRect.top + productMain.offsetHeight)) - 40;
      mainAbsoluteTopPosition = mainProductBreakpoint + mainRect.top;
      
    }, true);

    // On scroll
    if (sectionsHeight > 0) {
      window.addEventListener('scroll', (e) => {

        e.preventDefault();

        if (window.scrollY >= mainProductBreakpoint) {

          console.log(mainProductBreakpoint);

          if (productMain.style.position !== 'absolute') {
            productMain.style.position = 'absolute';
            productMain.style.top = mainAbsoluteTopPosition + 'px';
          }

        } else {

          productMain.style.position = '';
          productMain.style.top = '';

        }
  
      });
    }
    
  }

  function productMainToggle(productMain) {

    const mainToggleButtons = document.querySelectorAll('[data-product-main-toggle]');

    if (mainToggleButtons.length > 0) {

      mainToggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {

          e.preventDefault();

          productMain.classList.toggle('active');

        });
      });
      
    }
    
  }


  const productMain = document.querySelector('[data-product-main]');
  if (productMain !== null && productMain !== undefined) {

    // Init
    productMainPosition(productMain);

    // Mobile: toggle
    productMainToggle(productMain);

  }


  // === Product Selects

  // Selects toggle

  const productSelectsToggle = document.querySelectorAll('[data-product-select-toggle], .product-form__input input[type=radio]+label');

  if (productSelectsToggle.length > 0) {

    productSelectsToggle.forEach(btnToggle => {

      btnToggle.addEventListener('click', (e) => {
        e.stopPropagation();

        const parent = btnToggle.closest('.product-form__input');
        const allSelect = document.querySelectorAll('.product-form__input');

        if (parent !== null && parent !== undefined) {
          
          if (allSelect.length > 0) {

            allSelect.forEach(select => {
  
              if (select !== parent) {
                select.classList.remove('active');
              } else {
                select.classList.toggle('active');
              }
              
            });
            
          } else {
  
            parent.classList.toggle('active');
  
          }

        }

      });
      
    });
    
  }

  // Close select if open

  const productSelects = document.querySelectorAll('.product-form__input');
  if (productSelects.length > 0) {
    document.addEventListener('click', (e) => {
      if (!e.target.matches('[data-product-select-toggle], .product-form__input input[type=radio], .product-form__input input[type=radio]+label')) {
        productSelects.forEach(select => {
          select.classList.remove('active');
        });
      }
    });
  }

  // Init select option type 'date'

  const selectDateInputChecked = document.querySelector('[data-product-date-input-checked]+label');

  if (selectDateInputChecked !== null && selectDateInputChecked !== undefined) {

    const parent = selectDateInputChecked.closest('.product-form__input');
    if (parent !== null && parent !== undefined) {
      parent.classList.toggle('active');
    }

    selectDateInputChecked.click();

    document.querySelector('[data-product-date-input-checked]').removeAttribute('data-product-date-input-checked');
    
  }

  
// === Product Reviews Preview

  const reviewsPreviewCustom = document.querySelector('[data-z-reviews-preview]');
  const reviewsPreviewCustomNote = document.querySelector('[data-z-reviews-preview-note]');
  const reviewsPreviewCustomNb = document.querySelector('[data-z-reviews-preview-nb]');

  const reviewsDefaultElem = document.querySelector('[data-reviews-preview-badge] .jdgm-prev-badge');

  if (reviewsPreviewCustom !== null && reviewsPreviewCustom !== undefined &&
    reviewsPreviewCustomNote !== null && reviewsPreviewCustomNote !== undefined &&
    reviewsPreviewCustomNb !== null && reviewsPreviewCustomNb !== undefined &&
    reviewsDefaultElem !== null && reviewsDefaultElem !== undefined) {

    const reviewsDefaultNote = reviewsDefaultElem.getAttribute('data-average-rating');
    const reviewsDefaultNb = reviewsDefaultElem.getAttribute('data-number-of-reviews');

    if (reviewsDefaultNote !== null && reviewsDefaultNote !== undefined &&
      reviewsDefaultNb !== null && reviewsDefaultNb !== undefined) {

      const reviewsNb = parseInt(reviewsDefaultNb);
      if (reviewsNb > 0) {

        const reviewsNote = (parseFloat(reviewsDefaultNote) * 2).toFixed(1);
        reviewsPreviewCustomNote.innerText = reviewsNote + '/10';

        reviewsPreviewCustomNb.innerText = `(${reviewsNb} avis)`;

        reviewsPreviewCustom.classList.remove('hide');
        
      }
      
    }
    
  }
});
